import { render, staticRenderFns } from "./StudyPlans.vue?vue&type=template&id=276ce090&scoped=true&"
import script from "./StudyPlans.vue?vue&type=script&lang=js&"
export * from "./StudyPlans.vue?vue&type=script&lang=js&"
import style0 from "./StudyPlans.vue?vue&type=style&index=0&id=276ce090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276ce090",
  null
  
)

export default component.exports